export default __webpack_public_path__ + "static/media/mob-full.7306d7c0.png";